/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import Vue from "vue";
import Vuex from "vuex";
import leadAPI from "~/api/lead";
import ROUTE from "~/constants/routes";
import router from "~/router";
import moment from "moment";
import lead from "../api/lead";

Vue.use(Vuex);

const state = {
  leads: {},
  leadsList: [],

  clients: {},
  clientsList: [],

  integrations: {},
  integrationsList: [],

  integrationHistory: {},
  integrationHistoryList: [],

  log: {},
  logList: [],

  queue: true,

  error: {},
  validationErrors: {},
  loadingProcess: false,
  successRegistration: false,
};

const mutations = {
  setError: (state, payload) => {
    state.error = payload;
  },
  setLoading: (state, payload) => {
    state.loadingProcess = payload;
  },
  setValidationErrors: (state, payload) => {
    state.validationErrors = payload;
  },

  setLeadsList: (state, payload) => {
    state.leadsList = payload;
  },
  setLeads: (state, payload) => {
    state.leads = payload;
  },

  setClientsList: (state, payload) => {
    state.clientsList = payload;
  },
  setClients: (state, payload) => {
    state.clients = payload;
  },

  setIntegrationsList: (state, payload) => {
    state.integrationsList = payload;
  },
  setIntegrations: (state, payload) => {
    state.integrations = payload;
  },

  setIntegrationHistoryList: (state, payload) => {
    state.integrationHistoryList = payload;
  },
  setIntegrationHistory: (state, payload) => {
    state.integrationHistory = payload;
  },

  setQueue: (state, payload) => {
    state.queue = payload;
  },

  setLogList: (state, payload) => {
    state.logList = payload;
  },
  setLog: (state, payload) => {
    state.log = payload;
  },
};

const actions = {
  // LEAD

  getLeadsList({ commit }, payload) {
    commit("setLoading", true);
    leadAPI
      .getLeadList(payload)
      .then((res) => {
        commit("setError", {});
        commit("setValidationErrors", {});
        const leads = res.data.data;
        for (let i = 0; leads.length > i; i++) {
          leads[i].created_at = moment(leads[i].createdAt).format("DD.MM.YYYY HH:mm");
          if (leads[i].depositCreatedAt) {
            leads[i].deposit_created_at = moment(leads[i].depositCreatedAt).format(
              "DD.MM.YYYY HH:mm",
            );
          }
          leads[i].country_id = leads[i].countryId ? leads[i].country.enName : "";
          leads[i].status_id = leads[i].statusId ? leads[i].status.name : "";
          leads[i].integration_id = leads[i].integrationId ? leads[i].integration?.[0]?.name : "";
          leads[i].first_name = leads[i].firstName;
          leads[i].last_name = leads[i].lastName;
          leads[i].campaign_internal = leads[i].campaignInternal;
          if (leads[i].deposit) {
            console.log(leads[i].deposit);
            leads[i].deposit_status = leads[i].deposit.status;
          }
          leads[i].deposit = leads[i].deposit && leads[i].deposit.deposit > 0 ? "Yes" : "No";
        }

        console.log(leads);
        commit("setLeadsList", leads);
        commit("setLeads", res.data);
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  //CLIENT

  getClientsList({ commit }, payload) {
    commit("setLoading", true);
    leadAPI
      .getClientList(payload)
      .then((res) => {
        commit("setError", {});
        commit("setValidationErrors", {});
        const clients = res.data.data;
        for (let i = 0; clients.length > i; i++) {
          let integrations_active = 0;
          for (let a = 0; clients[i].integrations.length > a; a++) {
            const int = clients[i].integrations[a];
            if (int.isActive) {
              integrations_active++;
            }
          }
          clients[i].integrations_count = clients[i].integrations.length;
          clients[i].integrations_active = integrations_active;
          clients[i].is_active = clients[i].isActive;
        }
        commit("setClientsList", clients);
        commit("setClients", res.data);
      })
      .catch((error) => {
        console.log(error);
        const { data } = error.response;
        commit("setError", data);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  createClient({ commit }, payload) {
    commit("setLoading", true);
    leadAPI
      .createClient(payload)
      .then((res) => {
        if (res.success) {
          commit("setError", {});
          commit("setValidationErrors", {});
          router.push({
            path: ROUTE.CLIENT_LIST.replace(":page", 1),
          });
        }
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
        if (data.errors) {
          commit("setValidationErrors", data.errors);
        }
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  editClient({ commit }, { url, editData }) {
    commit("setLoading", true);
    leadAPI
      .editClient(url, editData)
      .then((res) => {
        if (res.success) {
          commit("setError", {});
          commit("setValidationErrors", {});
          router.push({
            path: ROUTE.CLIENT_LIST.replace(":page", 1),
          });
        }
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
        if (data.errors) {
          commit("setValidationErrors", data.errors);
        }
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  //INTEGRATIONS

  getIntegrationsList({ commit }, payload) {
    commit("setLoading", true);
    leadAPI
      .getIntegrationList(payload)
      .then((res) => {
        commit("setError", {});
        commit("setValidationErrors", {});
        const integrations = res.data.data;
        for (let i = 0; integrations.length > i; i++) {
          integrations[i].created_at = moment(integrations[i].createdAt).format("DD.MM.YYYY HH:mm");
          integrations[i].client_id = integrations[i].client.name;
          integrations[i].send_counter = integrations[i].sendCounter;
          integrations[i].send_capacity = integrations[i].sendCapacity;
          integrations[i].is_active = integrations[i].isActive;
          integrations[i].send_success = integrations[i].sendSuccess;
          integrations[i].send_duplicate = integrations[i].sendDuplicate;
          integrations[i].send_error = integrations[i].sendError;
        }
        commit("setIntegrationsList", integrations);
        commit("setIntegrations", res.data);
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  getIntegrationHistoryList({ commit }, payload) {
    commit("setLoading", true);
    leadAPI
      .getIntegrationList(payload)
      .then((res) => {
        commit("setError", {});
        commit("setValidationErrors", {});
        const integrations = res.data.data;
        for (let i = 0; integrations.length > i; i++) {
          integrations[i].created_at = moment(integrations[i].createdAt).format("DD.MM.YYYY HH:mm");
          integrations[i].client_id = integrations[i].client.name;
          integrations[i].send_counter = integrations[i].sendCounter;
          integrations[i].send_capacity = integrations[i].sendCapacity;
          integrations[i].is_active = integrations[i].isActive;
          integrations[i].send_success = integrations[i].sendSuccess;
          integrations[i].send_duplicate = integrations[i].sendDuplicate;
          integrations[i].send_error = integrations[i].sendError;
        }
        commit("setIntegrationHistoryList", integrations);
        commit("setIntegrationHistory", res.data);
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  createIntegration({ commit }, payload) {
    commit("setLoading", true);
    leadAPI
      .createIntegration(payload)
      .then((res) => {
        if (res.success) {
          commit("setError", {});
          commit("setValidationErrors", {});
          router.push({
            path: ROUTE.INTEGRATION_LIST.replace(":page", 1),
          });
        }
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
        if (data.errors) {
          commit("setValidationErrors", data.errors);
        }
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  editIntegration({ commit }, { url, editData }) {
    commit("setLoading", true);
    leadAPI
      .editIntegration(url, editData)
      .then((res) => {
        if (res.success) {
          commit("setError", {});
          commit("setValidationErrors", {});
          router.push({
            path: ROUTE.INTEGRATION_LIST.replace(":page", 1),
          });
        }
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
        if (data.errors) {
          commit("setValidationErrors", data.errors);
        }
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  //log

  getLogList({ commit }, payload) {
    commit("setLoading", true);
    leadAPI
      .getGlobalLog(payload)
      .then((res) => {
        commit("setError", {});
        commit("setValidationErrors", {});
        const log = res.data.data;
        for (let i = 0; log.length > i; i++) {
          log[i].log_created_at = moment(log[i].logCreatedAt).format("DD.MM.YYYY HH:mm");
        }
        commit("setLogList", log);
        commit("setLog", res.data);
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },
};

const getters = {};

const feed = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
export default feed;
